"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _PeriodPane = _interopRequireDefault(require("./PeriodPane"));
var _ContactPane = _interopRequireDefault(require("./ContactPane"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
//租赁时效
//联系人
var _default = exports.default = {
  name: 'AuthOrgDialog',
  //组织授权
  components: {
    PeriodPane: _PeriodPane.default,
    ContactPane: _ContactPane.default
  },
  directives: {
    waves: _waves.default
  },
  props: ["authData"],
  data: function data() {
    return {
      activeName: 'period'
    };
  },
  created: function created() {},
  methods: {
    refreshTable: function refreshTable() {
      this.authData.visible = false;
      this.$emit("refreshTable");
    }
  }
};